export const formatCount = (num: number): string => {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num ? num.toString() : '0';
}


export const formatNumber = (value: any) => {
  console.log(value, 'formatNumber value');
  const number = Number(
    typeof value === "string"
      ? value.replace(/,/g, "")
      : value
  );

  if (Number.isNaN(number)) return "0";

  return new Intl.NumberFormat("en-US").format(number);
}